module.exports = __webpack_public_path__ + "static/media/logo_inm.27cc5dd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_inm.svg
// module id = 184
// module chunks = 0